import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();
  
  const routeMap = {
    '/dashboard-overview': 'Dashboard',
    '/printer-management': 'Impressoras',
    '/filament-inventory': 'Filamentos',
    '/marketplace-management': 'Marketplaces',
    '/cost-calculator': 'Calculadora',
    '/enhanced-cost-calculator': 'Calculadora',
    '/calculator': 'Calculadora',
    '/quick-calculator': 'Calculadora rápida',
    '/historico': 'Histórico',
    '/configuracoes': 'Configurações'
  };

  const generateBreadcrumbs = () => {
    if (customItems) return customItems;
    
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Início', path: '/dashboard-overview' }];
    
    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeMap?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1);
      
      if (currentPath !== '/dashboard-overview') {
        breadcrumbs?.push({ label, path: currentPath });
      }
    });
    
    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();
  
  if (breadcrumbs?.length <= 1) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Trilha de navegação">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          const isFirst = index === 0;
          
          return (
            <li key={crumb?.path} className="flex items-center space-x-2">
              {!isFirst && (
                <Icon 
                  name="ChevronRight" 
                  size={14} 
                  className="text-muted-foreground/50" 
                />
              )}
              {isLast ? (
                <span className="font-medium text-foreground truncate max-w-[200px] sm:max-w-[120px]">
                  {crumb?.label}
                </span>
              ) : (
                <Link
                  to={crumb?.path}
                  className="hover:text-foreground transition-colors truncate max-w-[150px] sm:max-w-[100px]"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;